import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../../service/local-storage.service';
import { MainService } from '../../service/main.service';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { ToasterServiceService } from '../../service/toaster.service';
import { ApiUrls } from '../../apiRouts';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
@Component({
  selector: 'app-water-reminder',
  templateUrl: './water-reminder.component.html',
  styleUrls: ['./water-reminder.component.scss']
})
export class WaterReminderComponent implements OnInit, OnDestroy {
  waterSelectValue: number = 0;
  achievedGoalValue: any;
  achievedGoalDays: number = 0;
  selectedWaterAmount: number = 0;
  totalWaterIntake: number = 0;
  waterAmounts: number[] = [150, 250, 350, 500, 750, 1000];
  waveHeight: number = 0;
  waterTargetData: any;
  waterId: any;
  private sub2: Subscription;

  constructor(
    private mainService: MainService,
    private _bottomSheet: MatBottomSheet,
    private localStorageService: LocalStorageService,
    public dialog: MatDialog,
    private toasterService: ToasterServiceService,
  ) {
    this.sub2 = this.mainService.sendFilterData().subscribe(res => {         
      this.waterSelectValue = res.water_consumption_target;
      this.waterId=res.water_id
      this.updateWaveHeight();
    });
  }

  ngOnInit() {
    this.getWaterTarget();        
  }

  getWaterTarget() {
    let data = {
      water_id: 0,
      user_id: Number(this.localStorageService.getItem('user_id')),
      is_active: "1",
      Action: 'WaterTarget',
    };
    this.mainService.postApi(ApiUrls.addWaterTarget, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.waterTargetData = res.water;
        this.waterSelectValue = this.waterTargetData[0].water_consumption_target;
        this.waterId = this.waterTargetData[0].water_id
        this.getTotalWaterIntake(this.waterId);        
      } else {
        this.toasterService.toastError(res.response);
      }
    })
  }

  ngOnDestroy() {
    if (this.sub2) {
      this.sub2.unsubscribe();
    }
  }

  getTotalWaterIntake(waterId:any){        
    this.mainService.getApi(ApiUrls.sumOfWaterConsumption + waterId).subscribe((res: any) => {
      if (res.status == 1) {
        this.totalWaterIntake = parseInt(res.water_consumption[0].water_consumption, 10);        
        this.updateWaveHeight();
      }
    });      
  }

  updateWaveHeight() {
    if (this.waterSelectValue > 0) {
      this.waveHeight = (this.totalWaterIntake / this.waterSelectValue) * 100;
    } else {
      this.waveHeight = 0;
    }
  }

  setWaterAmount(amount: number) {
    this.selectedWaterAmount = amount;
    this.updateWaveHeight();
  }

  drinkWater(): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.addWater();
      }
    });
  }

  addWater() {
    let data = {
      water_consumption_id: 0,
      water_id: this.waterId,
      water_consumption: String(this.selectedWaterAmount),
      created: String(this.localStorageService.getItem('user_id')),
      is_active: "1",
      Action: 'INSERT',
    };
    this.mainService.postApi(ApiUrls.addWaterConsumption, data, 1).subscribe((res: any) => {
      if (res.status == 1) {        
        this.waterId = res.water_consumption[0].water_id
        this.getTotalWaterIntake(this.waterId);         
      } else {
        this.toasterService.toastError(res.response);
      }
    })
  }

  openBottomSheet(): void {
    this._bottomSheet.open(FilterMemberForm);
  }
}


@Component({
  selector: 'app-filter-member',
  templateUrl: 'filter-member.component.html',
  standalone: true,
  imports: [MatListModule, CommonModule, SharedModule],
})
export class FilterMemberForm {
  submitted = false;
  waterLevelForm: FormGroup;
  waterOfTarget: any;
  waterLevel: any = [
    { label: '1000 ml', value: '1000' },
    { label: '1500 ml', value: '1500' },
    { label: '2000 ml', value: '2000' },
    { label: '2500 ml', value: '2500' },
    { label: '3000 ml', value: '3000' },
    { label: '3500 ml', value: '3500' },
    { label: '4000 ml', value: '4000' },
    { label: '4500 ml', value: '4500' },
    { label: '5000 ml', value: '5000' },
  ];

  constructor(private _bottomSheetRef: MatBottomSheetRef<FilterMemberForm>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private mainService: MainService,
    private localStorageService: LocalStorageService,
    private toasterService: ToasterServiceService,
    private fb: FormBuilder
  ) {
    this.waterLevelForm = this.fb.group({
      waterLevel: [''],
    })
  }

  Cancel() {
    this._bottomSheetRef.dismiss();
  }

  submit() {   
    this.submitted = true;
    if (this.waterLevelForm.valid) {
      let data = {
        water_id: 0,
        user_id: Number(this.localStorageService.getItem('user_id')),
        water_consumption_target: String(this.waterLevelForm.value.waterLevel),
        created: String(this.localStorageService.getItem('user_id')),
        is_active: "1",
        Action: 'INSERT',
      };
      this.mainService.postApi(ApiUrls.addWaterTarget, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.waterOfTarget = res.water[0]
          this.mainService.getFilterData(this.waterOfTarget);
          this.waterLevelForm.reset();
          this.submitted = false;
          this._bottomSheetRef.dismiss();
          this.toasterService.toastSuccess(res.response);
        } else {
          this.toasterService.toastError(res.response);
        }
      })
    }
  }

}
